import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy } from '@angular/core';



@Directive({
    selector: '[currencyMask][forceCursorEnd]'
  })
  export class ForceCursorEndDirective implements AfterViewInit, OnDestroy {
    private observer: MutationObserver | undefined;
    private inputElement: HTMLInputElement;
    private events = ['click', 'focus', 'input', 'keyup', 'keydown'];
  
    constructor(private el: ElementRef) {
      this.inputElement = this.el.nativeElement;
    }
  
    ngAfterViewInit() {
      // Configurar eventos para todos os tipos de interação
      this.events.forEach(eventName => {
        this.inputElement.addEventListener(eventName, () => this.moveCursorToEnd());
      });
  
      // Observar mudanças no conteúdo do input
      this.observer = new MutationObserver(() => this.moveCursorToEnd());
      this.observer.observe(this.inputElement, { 
        attributes: true, 
        childList: true, 
        characterData: true,
        subtree: true
      });
      
      // Mover cursor para o final inicialmente
      this.moveCursorToEnd();
    }
  
    ngOnDestroy() {
      // Limpar eventos e observer
      this.events.forEach(eventName => {
        this.inputElement.removeEventListener(eventName, () => this.moveCursorToEnd());
      });
      
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  
    private moveCursorToEnd() {
      setTimeout(() => {
        if (this.inputElement && document.activeElement === this.inputElement) {
          const length = this.inputElement.value.length;
          this.inputElement.setSelectionRange(length, length);
        }
      }, 0);
    }
  }